import * as React from 'react';
import { SVGProps } from 'react';

const IconMMPSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 1H8v2h1.5L7.417 13H4v2h16v-2h-3.417L14.5 3H16V1zm-1.46 12H9.46l1.666-8h1.748l1.666 8z"
    />
    <path d="m23 18-2.953 1.23a3 3 0 0 1-2.204-.19l-1.308-.655a1 1 0 0 0-.962.037l-.682.41a3 3 0 0 1-2.725.184l-1.707-.731a1 1 0 0 0-.841.024l-1.39.695a3 3 0 0 1-2.396.126l-2.367-.887a1 1 0 0 0-.798.042L1 19.005v-2l.773-.51a3 3 0 0 1 2.395-.125l2.367.887a1 1 0 0 0 .798-.042l1.39-.695a3 3 0 0 1 2.523-.074l1.708.732a1 1 0 0 0 .908-.062l.682-.409a3 3 0 0 1 2.885-.11l1.309.654a1 1 0 0 0 .734.063L23 16v2zM2 21h20v2H2v-2z" />
  </svg>
);
export default IconMMPSizeM;
